import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { BadgeModule } from 'primeng/badge';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PopoverModule } from 'primeng/popover';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { TableModule } from 'primeng/table';
import { BehaviorSubject } from 'rxjs';
import { IColumn, ITable } from '@/interface/general/ITable';
import { HttpService } from '@/Services/http.service';
import { environment } from 'src/environments/environment';
import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import {
  FilaTabla,
  IServerSide,
  IServerSideBack,
} from './interface/table-of-items.interface';
import { HttpParams } from '@angular/common/http';
import { IResponseApiSS } from '@/interface/general/IResponseApi';
import { IDataPagination } from '@/interface/general/IPagination';
@Component({
  selector: 'app-table-of-items',
  templateUrl: './table-of-items.component.html',
  styleUrls: ['./table-of-items.component.scss'],
  standalone: true,
  imports: [
    TableModule,
    ButtonModule,
    CommonModule,
    FormsModule,
    DialogModule,
    SelectModule,
    BadgeModule,
    OverlayPanelModule,
    PopoverModule,
    IconFieldModule,
    InputIconModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DialogService],
})
export class TableOfItemComponent implements OnInit {
  filasTransformadas: FilaTabla[] = [];
  data!: IDataPagination<any>;
  totalRecords = 0;
  currentPagination?: IServerSide;

  tableSubject$ = new BehaviorSubject<ITable | null>(null);
  private httpService = inject(HttpService);
  private changeDetectorRef = inject(ChangeDetectorRef);
  private config = inject(DynamicDialogConfig);

  urlApi!: string;
  IdfdArchivo!: number;
  columns: IColumn[] = [];
  // Configuración de paginación
  rowsPerPageOptions = environment.paginationLarge;
  rowsPerPage = this.rowsPerPageOptions[0];

  ngOnInit() {
    const { IdfdArchivo, urlApi, columns } = this.config.data || {};
    this.IdfdArchivo = IdfdArchivo;
    this.urlApi = urlApi;
    this.columns = columns ?? [];
    this.filasTransformadas = []; //reset de datos

    this.setTable();
    this.onLoadRecords({ first: 0, rows: this.rowsPerPage });
  }
  //#region Configuración de tabla
  setTable() {
    const table: ITable = {
      fieldId: 'IdMulti',
      paginator: true,
      rowsPerPageOptions: this.rowsPerPageOptions,
      lazyLoadOnInit: true,
      columns: this.columns,
    };

    this.tableSubject$.next(table);
  }
  //#endregion

  //#region Carga de registros
  async onLoadRecords(event?: any) {
    if (!event || Object.keys(event).length === 0) return;

    const serverSide: IServerSide = {
      first: event.first ?? 0,
      rows: event.rows ?? this.rowsPerPage,
      sortField: event.sortField ?? '',
      sortOrder: event.sortOrder ?? 0,
      filters: event.filters ?? null,
      globalFilter: event.globalFilter ?? null,
    };

    // Armar objeto para backend
    const params: IServerSideBack = {
      IdfdArchivo: this.IdfdArchivo,
      ServerSide: serverSide,
    };

    const httpParams = this.convertToHttpParams(params);
    await this.callHttpService(httpParams);
  }

  async callHttpService(httpParams: HttpParams) {
    try {
      this.httpService.GetParams(this.urlApi, httpParams).subscribe({
        next: (resp: IResponseApiSS) => {
          const { data, metadataServerSide } = resp;

          // 🔄 Transformar y organizar la data si es necesario
          this.filasTransformadas = this.transformarParaTabla(data);

          const datosTabla: IDataPagination<any> = {
            data: this.filasTransformadas,
            pagination: {
              first:
                (metadataServerSide?.numeroPagina ?? 0) *
                (metadataServerSide?.filasxPagina ?? this.rowsPerPage),
              rows: metadataServerSide?.filasxPagina ?? this.rowsPerPage,
            },
            totalRecords: metadataServerSide?.totalRegitros ?? 0,
          };

          this.totalRecords = datosTabla.totalRecords ?? 0;
          this.data = datosTabla;

          this.changeDetectorRef.markForCheck();
        }
      });
    } catch (error) {
    }
  }

  private convertToHttpParams(params: IServerSideBack): HttpParams {
    let httpParams = new HttpParams();

    if (params.IdfdArchivo) {
      httpParams = httpParams.append('IdfdArchivo', params.IdfdArchivo);
    }

    if (params.ServerSide) {
      httpParams = httpParams.append(
        'ServerSide',
        JSON.stringify(params.ServerSide)
      );
    }

    // httpParams = httpParams.append(
    //   'ExportExcel',
    //   params.ExportExcel.toString()
    // );

    return httpParams;
  }
  //#endregion

  //#region Agrupación visual
  transformarParaTabla(data: any[]): FilaTabla[] {
    if (!data || data.length === 0) return [];

    const grupos: Record<string, any[]> = {};

    data.forEach((item) => {
      if (!grupos[item.tipo]) grupos[item.tipo] = [];
      grupos[item.tipo].push(item);
    });

    const resultado: FilaTabla[] = [];

    Object.entries(grupos).forEach(([tipo, items]) => {
      items.forEach((item, index) => {
        resultado.push({
          IdMulti: item.IdMulti,
          IdPaquete: item.IdPaquete,
          tipo: index === 0 ? tipo : null,
          Ano: item.Ano,
          rowspan: index === 0 ? items.length : null,
        });
      });
    });

    return resultado;
  }
  //#endregion
}
